import type { ReportJobTypes } from '@vy/types';
import { REPORT_JOB_TYPES } from '@vy/types';
import { raiseUnreachable } from '@vy/utils';
import { TriggerAnonymousCustomersReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerAnonymousCustomersReportJobForm';
import { TriggerCommitmentUsageReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerCommitmentUsageReportJobForm';
import { TriggerContractsReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerContractsReportJobForm';
import { TriggerCustomersReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerCustomersReportJobForm';
import { TriggerMonthlyClosureReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerMonthlyClosureReportJobForm';
import { TriggerProductsUsageReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerProductsUsageReportJobFrom';
import { TriggerUnchargedUsageReportJobForm } from '../reports-page-components/trigger-report-job-dialog/report-job-forms/TriggerUnchargedUsageReportJobForm';
import type { TriggerReportJobFormProps } from '../reports-page-components/trigger-report-job-dialog/TriggerReportJobDialog';

export function getSelectedReportJobForm(
  reportJobType: ReportJobTypes,
  props: TriggerReportJobFormProps,
): React.ReactElement<TriggerReportJobFormProps> {
  switch (reportJobType) {
    case REPORT_JOB_TYPES.CommitmentUsage:
      return <TriggerCommitmentUsageReportJobForm {...props} />;
    case REPORT_JOB_TYPES.UnchargedUsage:
      return <TriggerUnchargedUsageReportJobForm {...props} />;
    case REPORT_JOB_TYPES.ProductsUsage:
      return <TriggerProductsUsageReportJobForm {...props} />;
    case REPORT_JOB_TYPES.Contracts:
      return <TriggerContractsReportJobForm {...props} />;
    case REPORT_JOB_TYPES.AnonymousCustomers:
      return <TriggerAnonymousCustomersReportJobForm {...props} />;
    case REPORT_JOB_TYPES.MonthlyClosure:
      return <TriggerMonthlyClosureReportJobForm {...props} />;
    case REPORT_JOB_TYPES.Customers:
      return <TriggerCustomersReportJobForm {...props} />;
    case REPORT_JOB_TYPES.UnapprovedInvoices:
    case REPORT_JOB_TYPES.UpcomingInvoices:
    case REPORT_JOB_TYPES.CustomerRevenue:
    case REPORT_JOB_TYPES.FailedInvoiceDeliveries:
    case REPORT_JOB_TYPES.Usage:
    case REPORT_JOB_TYPES.RecurringRevenue:
      return <></>;
    default:
      return raiseUnreachable(reportJobType);
  }
}
